import React, { useEffect, useRef, useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  Box,
  Card,
  CardContent,
  Button,
  Autocomplete,
  Tooltip,
  Skeleton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateFOB, updateLoading } from "../Redux/Reducer/FOBReducer";
import { updateEXW } from "../Redux/Reducer/EXWReducer";
import { updateDropDown } from "../Redux/Reducer/CityAndPortReducer";
import { updateDDP } from "../Redux/Reducer/DDPReducer";
import { updateCIF } from "../Redux/Reducer/CIFReducer";
import axiosInstance from "../Utils/AxoisClient";
import { updateCurrencyList } from "../Redux/Reducer/CurrencyList";
import { useNavigate } from "react-router-dom";

const center = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: 800,
  minWidth: "160px",
  padding: "2px 4px",
  maxWidth: "160px",
};

const buttonStyle = {
  fontSize: "0.75rem !important",
  minWidth: "40px",
  marginTop: "3px !important",
  opacity: 0.8,
  background: "#7847dc",
  textTransform: "none",
  borderRadius: 10,
  paddingBottom: "3px important",
  marginLeft: "8px",
  width: "70px",
  borderRadius: 10,
  paddingBottom: "3px important",
};

const cardStyle = {
  mt: 1.5,
  ml: 1.5,
  mr: 1.5,
  borderRadius: "16px",
  boxShadow: "0 8px 28px rgba(44, 0, 62, 0.14)",
  pb: 0,
  position: "relative",
  background:
    "linear-gradient(90deg,rgba(120, 71, 220, 0) -5.62%,#5526b7 126.61%),#000",
  color: "#fff",
  transition: "box-shadow 0.25s ease, transform 0.25s ease",
  "&:hover": {
    boxShadow: "0 14px 36px rgba(44, 0, 62, 0.2)",
    transform: "translateY(-2px)",
  },
};

const cardContent = {
  display: "flex",
  justifyContent: "center",
  paddingBottom: "2px !important",
  padding: "0px !important",
  flexDirection: "column",
};

const cityAndPortContainer = {
  width: "100%",
  paddingBottom: "0px !important",
  overflowY: "hidden",
};

const containerHeader = {
  display: "flex",
  background:
    "linear-gradient(90deg, rgba(120, 71, 220, 0) -5.62%, #5526b7 126.61%), #000;",
  color: "white",
  padding: "10px 0px 10px 0px",
  borderRadius: "16px 16px 0px 0px",
  width: "100%",
  justifyContent: "center",
  marginBottom: "14px",
};

const textHeader = {
  color: "white",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "normal",
  letterSpacing: "-0.387px",
  fontSize: "16px",
  color: "white",
};
const rowName = {
  ...center,
  ...textHeader,
  justifyContent: "flex-start",
  width: "190px !important",
  minWidth: "190px !important",
  padding: "2px 4px",
  // color: "rgba(0, 0, 0, 0.80)",
  fontSize: "14px",
  flexShrink: 1,
  background: "transparent",
};

const selectBoxStyle = {
  color: "var(--entered-text, #2C2C2E)",
  // color:'white',
  background: "white",
  fontSize: "12px !important",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal",
  letterSpacing: "-0.262px",
  maxHeight: "28px",
  borderRadius: 1,
  // border: ".5px solid white",
  "& .MuiOutlinedInput-notchedOutline": {
    // border: "1px solid rgba(21, 55, 209, 0.10)",
    border: "none",
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};
const dropDownStyle = {
  borderRadius: "2px",
  minHeight: "25px",
  "& .MuiInputBase-root": {
    padding: "0 6px",
    fontSize: "12px",
    minHeight: "25px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "2px",
    border: "none",
  },
  "& .MuiInputBase-input": {
    fontSize: "12px !important",
    padding: "4px 6px !important",
  },
};
const dropDownFont = {
  color: "var(--entered-text, #2C2C2E)",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "20px",
};
const autocompleteStyle = {
  width: "100%",
  "& .MuiAutocomplete-option": {
    fontSize: "10px",
    minHeight: "28px",
  },
  "& .MuiAutocomplete-listbox": {
    paddingTop: 0,
    paddingBottom: 0,
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "5px",
    fontSize: "11px",
    minHeight: "28px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "5px",
    border: "1px solid rgba(21, 55, 209, 0.10)",
  },
};
const PortAndCityRow = ({
  goButton,
  originCountryDetails,
  selectedHeader,
  executeScroll,
  setGoButton,
  handleToggle,
  from,
  currencyList,
  scrollToDownRef,
}) => {
  const [countries, setCountries] = useState([]);
  const [fobValues, setFobValues] = useState({});
  const [exwValue, setExwValues] = useState({});
  const [cifValues, setCifValues] = useState({});
  const [selectedValues, setSelectedValues] = useState({});
  // const [city, setCity] = useState([]);
  // const [port, setPort] = useState([]);
  // const [dropDown, setDropDown] = useState(dropDownJSON.DropDown[0]);
  const [checkValue, setCheckValue] = useState(true);
  const [dropDownData, setDropDownData] = useState([]);
  const [selectedCurrencyValue, setSelectedCurrencyValue] = useState({});
  const navigate = useNavigate();
  const textref = useRef([]);
  const [textDropDown, setTextDropDown] = useState([]);
  const [loader, setLoader] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const quotationName = {
      EXW: "EX Works",
      FOB: "FOB",
      CIF: "CIF",
    };
    const result = originCountryDetails?.map((ele) => ele?.origin_country);
    const textDropDown = originCountryDetails?.map((ele) => {
      return {
        Country: ele?.origin_country,
        value: ele?.price_quotation_type
          ? quotationName[ele?.price_quotation_type]
          : "EX Works",
      };
    });

    setTextDropDown(textDropDown);
    setCountries(result);

    if (result.length > 0) setLoader(false);

    const exw = {};
    const fob = {};
    const cif = {};

    originCountryDetails?.forEach((item) => {
      const country = item?.origin_country;
      const type = item?.price_quotation_type
        ? quotationName[item?.price_quotation_type]
        : "EX Works";
      const quotation = item?.quotation ? item?.quotation : "";

      if (quotation && country) {
        if (type === "EX Works") exw[country] = quotation;
        else if (type === "FOB") fob[country] = quotation;
        else if (type === "CIF") cif[country] = quotation;
      }
    });

    setExwValues(exw);
    setFobValues(fob);
    setCifValues(cif);
    const selectedValues = {};

    result.forEach((country) => {
      const value = prioritizeSort(currencyList, country);
      const originData = originCountryDetails?.find(
        (ele) => ele?.origin_country === country
      );
      const currencyValue = originData?.currency_value;
      const matchedCurrency = value.find((ele) => ele?.code === currencyValue);
      selectedValues[country] = matchedCurrency || value[0] || null;
    });
    setSelectedCurrencyValue(selectedValues);
  }, [originCountryDetails, currencyList]);

  const isAllEmpty = (obj) => {
    return Object.values(obj).every(
      (value) => value === "" || value === null || value === undefined
    );
  };

  useEffect(() => {
    setCheckValue(
      isAllEmpty(fobValues) && isAllEmpty(exwValue) && isAllEmpty(cifValues)
    );
  }, [exwValue, fobValues]);

  const handleInputChangeInputValue = (country, key, value) => {
    if (key === "FOB") {
      setFobValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          [country]: value,
        };
        return updatedValues;
      });
      setExwValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          [country]: "",
        };
        return updatedValues;
      });
      setCifValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          [country]: "",
        };
        return updatedValues;
      });
    } else if (key === "EX Works") {
      setExwValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          [country]: value,
        };
        return updatedValues;
      });
      setFobValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          [country]: "",
        };
        return updatedValues;
      });
      setCifValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          [country]: "",
        };
        return updatedValues;
      });
    } else if (key === "CIF") {
      setCifValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          [country]: value,
          isValueFromHeader: true,
        };
        return updatedValues;
      });
      setFobValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          [country]: "",
        };
        return updatedValues;
      });
      setExwValues((prevValues) => {
        const updatedValues = {
          ...prevValues,
          [country]: "",
        };
        return updatedValues;
      });
    }
  };

  const handleChange = (country, field, event) => {
    const newValue = event.target.value;
    setSelectedValues((prev) => ({
      ...prev,
      [country]: {
        ...(prev[country] || {}),
        [field]: newValue,
      },
    }));

    setDropDownData((prevState) => {
      const updatedData = prevState.map((item) => {
        if (item.country === country) {
          return {
            ...item,
            selectedCity: field === "city" ? newValue : item.selectedCity,
            selectedPort: field === "port" ? newValue : item.selectedPort,
          };
        }
        return item;
      });
      const updatedFilteredCountries = updatedData.filter((item) =>
        countries.includes(item.country)
      );

      dispatch(updateDropDown(updatedFilteredCountries));
      return updatedData;
    });
  };

  useEffect(() => {
    if (
      !Array.isArray(originCountryDetails) ||
      originCountryDetails?.length === 0
    )
      return;

    const dropDownList = [];
    const cityList = [];
    const portList = [];
    const quotationList = [];
    const initialSelections = {};

    originCountryDetails?.forEach((item) => {
      const country = item?.origin_country?.trim();
      if (!country) return;

      const portCities = Array.isArray(item.origin_port)
        ? item.origin_port
        : [];
      const factoryCities = Array.isArray(item.origin_city)
        ? item.origin_city
        : [];
      const quotationType = Array.isArray(item.price_quotation_type)
        ? item.price_quotation_type
        : [];

      dropDownList.push({
        country,
        port: portCities,
        city: factoryCities,
      });
      cityList.push({ country, city: factoryCities });
      portList.push({ country, port: portCities });
      quotationList.push({
        Country: country,
        value: quotationType ? quotationType : "",
      });

      // ✅ Set first city and port as default selection
      initialSelections[country] = {
        city: factoryCities[0] ?? "",
        port: portCities[0] ?? "",
      };
    });

    setDropDownData(dropDownList);
    // setCity(cityList);
    // setPort(portList);

    setSelectedValues(initialSelections);

    const firstMatches = countries
      .map((country) =>
        dropDownList?.find(
          (item) => item?.country?.toLowerCase() === country?.toLowerCase()
        )
      )
      .filter(Boolean);
    dispatch(updateDropDown(firstMatches));
  }, [originCountryDetails, countries]);

  const getCitiesByCountry = (country) => {
    const filtered = originCountryDetails?.filter(
      (item) =>
        country &&
        item?.origin_country?.toLowerCase() === country?.toLowerCase()
    );

    const allCities = filtered.flatMap((item) => item?.origin_city);

    return [...new Set(allCities)];
  };

  const getPortByCountry = (country) => {
    const filtered = originCountryDetails?.filter(
      (item) =>
        country &&
        item?.origin_country?.toLowerCase() === country?.toLowerCase()
    );
    const allPort = filtered.flatMap((item) => item?.origin_port);

    return [...new Set(allPort)];
  };

  function handleReset() {
    setFobValues({});
    setExwValues({});
    setCifValues({});
    dispatch(updateEXW({}));
    dispatch(updateFOB({}));
    dispatch(updateCIF({}));
    dispatch(updateDDP({}));
    setGoButton(false);
  }

  useEffect(() => {
    if (checkValue) {
      setGoButton(false);
      dispatch(updateEXW({}));
      dispatch(updateFOB({}));
      dispatch(updateCIF({}));
      setTimeout(() => {
        dispatch(updateDDP({}));
      }, 1);
    } else {
      // setGoButton(true);
    }
  }, [checkValue]);

  // function handleGoButton() {
  //   dispatch(updateEXW(exwValue));
  //   dispatch(updateFOB(fobValues));
  //   dispatch(updateCIF(cifValues));
  //   handleToggle();
  // }

  function handleGoButton() {
    // const applyCurrencyRate = (values) => {
    //   const updatedValues = {};
    //   Object.entries(values).forEach(([country, val]) => {
    //     const rate = selectedCurrencyValue[country]?.rate || 1;
    //     const numericValue = parseFloat(val || 0);

    //     updatedValues[country] = +(numericValue / rate).toFixed(2);
    //   });
    //   return updatedValues;
    // };
    const applyCurrencyRate = (values) => {
      const updatedValues = {};
      Object.entries(values).forEach(([country, val]) => {
        if (val === "") {
          updatedValues[country] = ""; // Preserve empty string
        } else {
          const rate = selectedCurrencyValue[country]?.rate || 1;
          const numericValue = parseFloat(val);
          updatedValues[country] = +(numericValue / rate).toFixed(2);
        }
      });
      return updatedValues;
    };

    const updatedEXW = applyCurrencyRate(exwValue);
    const updatedFOB = applyCurrencyRate(fobValues);
    const updatedCIF = applyCurrencyRate(cifValues);

    dispatch(updateEXW(updatedEXW));
    dispatch(updateFOB(updatedFOB));
    dispatch(updateCIF(updatedCIF));
    dispatch(updateCurrencyList(selectedCurrencyValue));
    handleToggle();
  }

  const handleChangeTextDropDown = (country, type, e) => {
    const value = e.target.value;
    setTextDropDown((prevTextDropDown) =>
      prevTextDropDown.map((countryName) => {
        if (countryName.Country === country) {
          textref.current = [
            ...textref.current,
            { ...countryName, value: value },
          ];
          return { ...countryName, value: value };
        } else {
          return countryName;
        }
      })
    );
  };

  const prioritizeSort = (arr, targetCountry) => {
    const priorityOrder = [
      (item) => item.country === targetCountry,
      (item) => item.code === "USD",
      (item) => item.code === "EUR",
      (item) => item.code === "CNY",
    ];

    return [...arr].sort((a, b) => {
      const aPriority = priorityOrder.findIndex((fn) => fn(a));
      const bPriority = priorityOrder.findIndex((fn) => fn(b));
      const aRank = aPriority === -1 ? Infinity : aPriority;
      const bRank = bPriority === -1 ? Infinity : bPriority;

      return aRank - bRank;
    });
  };

  function updateCurrency(value, country) {
    setSelectedCurrencyValue((prevValues) => {
      const updatedValues = {
        ...prevValues,
        [country]: value,
      };
      return updatedValues;
    });
  }

  useEffect(() => {
    if (goButton) {
      handleGoButton();
    }
  }, [goButton, exwValue]);

  

  return (
    <Card sx={{ ...cardStyle, overflow: "hidden" }}>
      <CardContent sx={{ ...cardContent }}>
        <Box sx={{ ...cityAndPortContainer, width: "100%" }}>
          <Box sx={{ mt: 2 }}>
            {/* Scrollable Content Container */}

            {loader ? (
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.2,
                      px: 2.5,
                      py: 1.3,
                      borderRadius: "12px",
                      background: "linear-gradient(90deg, #ff6a6a, #ff4d4d)",
                      color: "#fff",
                      fontWeight: 500,
                      boxShadow: "0 10px 25px rgba(255, 77, 77, 0.35)",
                      fontSize: "14px",
                    }}
                  >
                    ⚠️ Please select required Category, Origin & Destination Country to proceed.
                  </Box>
                </Box>
                {[1, 2, 3].map((ele) => (
                  <Box key={ele} className="center" sx={{ display: "flex" }}>
                    {[1, 2].map((inner) => (
                      <Box
                        key={`${ele}-${inner}`}
                        sx={{ width: 200, mb: 2, mr: inner === 1 ? 1 : 0 }}
                      >
                        <Skeleton sx={{ background: "#ddd5ed9e" }} />
                        <Skeleton
                          animation="wave"
                          sx={{ background: "#ddd5ed9e" }}
                        />
                        <Skeleton
                          animation={false}
                          sx={{ background: "#ddd5ed9e" }}
                        />
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>
            ) : countries.length > 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: "fit-content",
                }}
              >
                {/* Header Row */}
                <Box
                  sx={{
                    ...containerHeader,
                  }}
                >
                  <Box
                    className="sticky-column-port"
                    sx={{
                      ...rowName,
                      color: "white",
                      backgroundColor: "transparent !important",
                    }}
                  >
                    Origin Country
                  </Box>
                  {countries.map((country, index) => (
                    <Box
                      key={`${country}-${index}`}
                      sx={{
                        ...center,
                      }}
                    >
                      <Box sx={{ ...textHeader }}>{country}</Box>
                    </Box>
                  ))}
                </Box>
                {/* port and city */}

                {[
                  {
                    label: "Origin City",
                    key: "city",
                    options: getCitiesByCountry,
                  },
                  {
                    label: "Origin Port",
                    key: "port",
                    options: getPortByCountry,
                  },
                ].map(({ label, key, options }) => (
                  <Box
                    key={label}
                    sx={{
                      display: "flex",
                      marginBottom: "5px",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        ...rowName,
                      }}
                      className="sticky-column-port"
                    >
                      <Box variant="caption">{label}</Box>
                    </Box>
                    {countries.map((country, index) => {
                      const list = options(country);
                      return (
                        <Box
                          key={`${label}-${country}-${index}`}
                          sx={{
                            ...center,
                          }}
                        >
                          <Select
                            variant="standard"
                            disabled={from === "bookmark"}
                            // value={selected?.[key] ?? ""}
                            value={selectedValues?.[country]?.[key] ?? ""}
                            onChange={(e) => handleChange(country, key, e)}
                            sx={{ ...selectBoxStyle, ...dropDownStyle }}
                            fullWidth
                            size="small"
                            displayEmpty
                          >
                            {list.map((val, idx) => (
                              <MenuItem
                                key={idx}
                                value={val}
                                sx={{ ...dropDownFont }}
                              >
                                {val}
                              </MenuItem>
                            ))}
                          </Select>
                        </Box>
                      );
                    })}
                  </Box>
                ))}

                {/* Price Quotation Type */}
                <Box
                  sx={{
                    display: "flex",
                    marginBottom: "7.5px",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      ...rowName,
                    }}
                    className="sticky-column-port"
                  >
                    <Box variant="caption">Price Quotation Type</Box>
                  </Box>
                  {countries.map((country, index) => {
                    const selected =
                      textDropDown &&
                      textDropDown.find((item) => item.Country === country);

                    return (
                      <Box
                        key={`quoteType-${country}-${index}`}
                        sx={{
                          ...center,
                        }}
                      >
                        <Select
                          variant="standard"
                          disabled={from === "bookmark"}
                          displayEmpty
                          value={selected?.value ?? "EX Works"}
                          onChange={(e) =>
                            handleChangeTextDropDown(country, "port", e)
                          }
                          sx={{
                            ...selectBoxStyle,
                            ...dropDownStyle,
                          }}
                          fullWidth
                          size="small"
                        >
                          <MenuItem value="EX Works" sx={{ ...dropDownFont }}>
                            EX Works
                          </MenuItem>
                          <MenuItem value="FOB" sx={{ ...dropDownFont }}>
                            FOB
                          </MenuItem>
                          <MenuItem value="CIF" sx={{ ...dropDownFont }}>
                            CIF
                          </MenuItem>
                        </Select>
                      </Box>
                    );
                  })}
                </Box>

                {/* currency update  */}

                <Box
                  sx={{
                    display: "flex",
                    marginBottom: "7.5px",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      ...rowName,
                    }}
                    className="sticky-column-port"
                  >
                    <Box variant="caption">Local Currency (LC)</Box>
                  </Box>
                  {countries.map((country, index) => {
                    const result = prioritizeSort(currencyList, country);
                    return (
                      <Box
                        key={`quoteType-${country}-${index}`}
                        sx={{
                          ...center,
                        }}
                      >
                        <Autocomplete
                          value={selectedCurrencyValue[country] || null}
                          disabled={from === "bookmark"}
                          onChange={(event, newValue) => {
                            updateCurrency(newValue, country);
                          }}
                          options={result || []}
                          isOptionEqualToValue={(option, value) =>
                            option?.code === value?.code
                          }
                          getOptionLabel={(option) =>
                            `${option.code} - ${
                              option.countryShort || option.country
                            }`
                          }
                          renderOption={(props, option) => (
                            <li
                              key={option?.code}
                              {...props}
                              style={{ fontSize: "12px" }}
                            >
                              {`${option.code} - ${
                                option.countryShort || option.country
                              }`}
                            </li>
                          )}
                          renderInput={(params) => {
                            const selectedOption = result.find(
                              (opt) =>
                                `${opt.code} - ${
                                  opt.countryShort || opt.country
                                }` === params.inputProps.value
                            );
                            const tooltipTitle = selectedOption
                              ? `${selectedOption.code} - ${
                                  selectedOption.countryShort ||
                                  selectedOption.country
                                }`
                              : "";

                            return (
                              <Tooltip title={tooltipTitle} arrow>
                                <TextField
                                  {...params}
                                  placeholder="Currency"
                                  size="small"
                                  variant="standard"
                                  sx={{
                                    ...selectBoxStyle,
                                    borderRadius: "2px",
                                    minHeight: "25px",
                                    "& .MuiInputBase-root": {
                                      padding: "0 6px",
                                      fontSize: "12px",
                                      minHeight: "25px",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderRadius: "3px",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "12px !important",
                                      padding: "4px 0 !important",
                                      border: "none",
                                    },
                                  }}
                                />
                              </Tooltip>
                            );
                          }}
                          sx={{
                            ...selectBoxStyle,
                            ...autocompleteStyle,
                          }}
                        />
                      </Box>
                    );
                  })}
                </Box>

                {/* Quotation Field */}
                <Box
                  sx={{
                    display: "flex",
                    marginBottom: "8px",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      ...rowName,
                    }}
                    className="sticky-column-port"
                  >
                    <Box variant="caption">Quotation (In LC/MT)</Box>
                  </Box>
                  {countries.map((country, index) => {
                    const res =
                      textDropDown &&
                      textDropDown.find((ele) => ele.Country === country);

                    const isDisabled = !res || res.value === "";
                    return (
                      <Box
                        key={`quoteInput-${country}-${index}`}
                        sx={{
                          ...center,
                        }}
                      >
                        <TextField
                          variant="outlined"
                          // disabled={from === "bookmark"}
                          value={
                            res?.value === "FOB"
                              ? fobValues[country] ?? ""
                              : res?.value === "EX Works"
                              ? exwValue[country] ?? ""
                              : res?.value === "CIF"
                              ? cifValues[country] ?? ""
                              : ""
                          }
                          disabled={from === "bookmark" || isDisabled}
                          sx={{
                            fontSize: "9px",
                            borderRadius: 1,
                            backgroundColor: isDisabled
                              ? "#e0e0e07a"
                              : "#E8EBFB",
                            opacity: isDisabled ? 0.5 : 1,
                            pointerEvents: isDisabled ? "none" : "auto",
                            "& fieldset": { border: "none" },
                          }}
                          onChange={(e) => {
                            dispatch(updateLoading(e.target.value));
                            handleInputChangeInputValue(
                              country,
                              res?.value,
                              e.target.value
                            );
                          }}
                          placeholder={`Enter ${res?.value} Value`}
                          fullWidth
                          inputProps={{
                            style: {
                              height: "26px",
                              padding: "0 6px",
                              fontSize: "12px",
                              border: "none",
                            },
                          }}
                          InputProps={{
                            sx: { borderRadius: 2, border: "none" },
                          }}
                        />
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            ) : (
              <span
                style={{
                  width: "100%",
                  height: "70px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Please select the required origin country to proceed
              </span>
            )}
          </Box>
        </Box>
        {/* Footer Buttons */}
        <Box className="port-city-footer-button">
          <Button
            disabled={checkValue}
            variant="contained"
            className="sticky-column-port"
            // onClick={() => navigate("/dashboard")}
            onClick={() => {
              setGoButton(true);
              handleGoButton();
              // navigate(-1);
              scrollToDownRef?.current?.scrollIntoView({ behavior: "smooth" });
            }}
            sx={{ ...buttonStyle, width: "auto" }}
          >
            Process To Cost Breakdown
            {/* Back to previous page */}
          </Button>
          <Box>
            <Button
              variant="contained"
              disabled={checkValue}
              // onClick={() => {
              //   setGoButton(true);
              //   handleGoButton();
              // }}
              onClick={() => {
                setGoButton(true);
                handleGoButton();
                // dispatch(updateEXW(exwValue));
                setTimeout(() => {
                  executeScroll();
                }, 1);
              }}
              sx={{
                ...buttonStyle,
              }}
            >
              Go
            </Button>
            <Button
              variant="contained"
              onClick={handleReset}
              sx={{
                ...buttonStyle,
              }}
            >
              Reset
            </Button>
          </Box>
          <Box>
            <Button></Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PortAndCityRow;
